<template>
  <button
    v-bind="$attrs"
    :style="btnStyle"
    :class="[btnClass, { 'element-load': isLoading }]"
  >
    <img
      v-if="icon"
      class="icon"
      :class="{
        'icon-right': this.iconPosition === 'right',
        [`icon-size-${iconSize}`]: this.icon,
        'bright-icon':
          this.variant === 'primary' && this.icon && this.brightIcon,
      }"
      :src="`/image/icons/${icon}.svg`"
      alt="icon"
    />
    <slot />
  </button>
</template>

<script>
import { isMobile } from "~/mixins/isMobile";

export default {
  name: "BaseButton",
  inheritAttrs: false,
  mixins: [isMobile],
  props: {
    variant: String,
    size: {
      type: String,
      default: "sm"
    },
    iconSize: {
      type: String,
      default: "sm"
    },
    color: {
      type: String,
      default: null
    },
    bold: {
      type: Boolean,
      default: false
    },
    isLoad: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: String,
      required: false
    },
    brightIcon: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: this.isLoad
    };
  },
  computed: {
    computedDisabled() {
      return this.disabled || this.$attrs.disabled || this.isLoading;
    },
    tooltipData() {
      if (this.tooltipContent) {
        return { content: this.tooltipContent, html: true };
      }
      return {};
    },
    btnClass() {
      return {
        "base-btn": true,
        "v-popper--has-tooltip": true,
        "bold-font": this.bold,
        [`size-${this.size}`]: true,
        [`base-btn-text-${this.size}`]: true,
        [`${this.getButtonColor()}`]: true,
        [this.variant]: true,
        fullwidth: this.fullWidth,
        disabled: this.computedDisabled,
        circle: this.circle,
        "icon-spacing": this.icon,
        "circle-icon-spacing": this.icon && this.circle
      };
    },
    btnStyle() {
      const buttonColor = this.getButtonColor();
      return {
        "background-color":
          this.variant === "primary" ? buttonColor : "transparent",
        border:
          this.variant === "primary"
            ? "1px solid transparent"
            : `1px solid ${buttonColor}`,
        color: this.variant === "primary" ? "white" : `${buttonColor}`
      };
    }
  },
  methods: {
    getButtonColor() {
      if (this.isLoading) {
        if (this.color && this.color.startsWith('red-')) {
          return 'red-3-load';
        } else if (this.color && this.color.startsWith('green-')) {
          return 'green-3-load';
        }
      }

      return `${this.color}-bg`
    }
  },
  watch: {
    isLoad(val) {
      this.isLoading = val;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/design/mainIncludes";

.base-btn {
  display: flex;
  box-sizing: border-box;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-family: "Museo Regular", sans-serif;
  font-weight: normal;
  //letter-spacing: 0.08em;
  border-radius: 4px;
  transition: 0.3s;

  outline: none;
  &.size-sm {
    padding: 10px 11px;
  }
  &.size-md {
    padding: 16px 40px;
  }
  &.icon-spacing {
    column-gap: 8px;
  }
  &.circle-icon-spacing {
    padding: 9px !important;
  }
  @include minWidth992 {
    &:hover {
      filter: brightness(0.9);
    }
  }
}

.fullwidth {
  width: 100%;
}

.circle {
  border-radius: 50px;
}

.disabled {
  color: #9DE0AA;
  //opacity: 0.4;
  cursor: not-allowed;
}

.option-btn {
  @include minWidth768 {
    display: none;
  }
}

.icon {
  width: 16px;
  height: 16px;
  &.icon-size-xs {
    height: 8px;
    width: 8px;
  }
  &.icon-size-md {
    height: 20px;
    width: 20px;
  }
  &.icon-size-lg {
    height: 24px;
    width: 24px;
  }
  &-right {
    order: 1;
  }
  &.bright-icon {
    filter: brightness(2);
  }
}

.v-popper--theme-tooltip .v-popper__inner {
  background: rgba(194, 11, 11, 0.8) !important;
  color: #942323 !important;
}
</style>